<!--
  功能：因子选择,可控制弹窗
  作者：wangwenhao
  邮箱：wangwenhao@gw.com.cn
  时间：
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：2026-01-15 17:18:27
-->
<template>
    <div class="factorSetOperator">
        <div class="actionSheet-title">
            <p class="name" @click="handleBack"><van-icon name="arrow-left" />已选因子组合池</p>
            <p class="handle-clear" @click="handleClear">清空组合池</p>
        </div>
        <!-- 交并集切换TAB -->
        <div class="actionSheet-tab">
            <div class="actionSheet-tab-bg">
                <span
                    class="actionSheet-tab-item"
                    :class="{ active: checkedYzType === 'jj' }"
                    @click="toggleYzType('jj')"
                    >交集</span
                >
                <span
                    class="actionSheet-tab-item"
                    :class="{ active: checkedYzType === 'bj' }"
                    @click="toggleYzType('bj')"
                    >并集</span
                >
            </div>
        </div>
        <!-- 交并集因子内容 -->
        <div class="actionSheet-content-hidden">
            <div class="actionSheet-content">
                <!-- 最外层 交/并因子 -->
                <div class="actionSheet-factor-info">
                    <van-row>
                        <draggable
                            :list="parentFactorList"
                            group="people"
                            :options="{
                                draggable: '.draggable-item',
                                filter: '.no-drag, .actionSheet-factor-non, .actionSheet-factor-del',
                                preventOnFilter: false
                            }"
                        >
                            <van-col
                                span="24"
                                class="actionSheet-factor-item-col draggable-item"
                                v-for="(factorP, indexP) in parentFactorList"
                                :key="indexP"
                            >
                                <!-- 常规因子 -->
                                <div class="actionSheet-factor-item" v-if="factorP.yzType == 0" >
                                    <div class="actionSheet-factor-item-text">
                                        <div class="actionSheet-factor-item-name">
                                            {{ factorP.FactorName }}
                                        </div>
                                        <div class="actionSheet-factor-item-desc">
                                            {{ factorP.SubClassName }}
                                        </div>
                                    </div>
                                    <div class="actionSheet-factor-item-num">
                                        <div
                                            class="actionSheet-factor-item-zf"
                                            :class="[judgeColor(factorP.RiZhangFu)]"
                                        >
                                            {{ toFixedNum(factorP.RiZhangFu * 100, 2, '%', true) }}
                                        </div>
                                        <div class="actionSheet-factor-item-zhi">
                                            {{ factorP.XinHaoShuLiang }}只
                                        </div>
                                        <!-- 非按钮 -->
                                        <div
                                            class="actionSheet-factor-non"
                                            @click.stop="parentToggleNon(factorP, indexP)"
                                        >
                                            <img
                                                src="@/assets/image/factor/non.png"
                                                alt=""
                                                srcset=""
                                                v-if="factorP.isNon"
                                            />
                                            <img
                                                src="@/assets/image/factor/non-n.png"
                                                alt=""
                                                srcset=""
                                                v-else
                                            />
                                        </div>
                                        <!-- 删除按钮 -->
                                        <div class="actionSheet-factor-del" @click="delYz(factorP)">
                                            <img
                                                src="@/assets/image/factor/del2.png"
                                                alt=""
                                                srcset=""
                                            />
                                        </div>
                                    </div>
                                </div>
                                <!-- 非常规 -->
                                 <div class="actionSheet-factor-item" v-else >
                                    <div class="actionSheet-factor-item-text others-left">
                                        <div class="actionSheet-factor-item-name">
                                            {{ factorP.FactorName }}
                                        </div>
                                        <div class="actionSheet-factor-item-desc">
                                            {{ factorP.SubClassName }}
                                        </div>
                                    </div>
                                    <div class="actionSheet-factor-item-num others-rigth">


                                        <!-- 删除按钮 -->
                                        <div class="actionSheet-factor-del" style="margin-left: auto;" @click="delYz(factorP)">
                                            <img
                                                src="@/assets/image/factor/del2.png"
                                                alt=""
                                                srcset=""
                                            />
                                        </div>
                                    </div>
                                </div>
                            </van-col>
                        </draggable>
                        <!-- 组合内的因子(内层) -->
                        <div
                            v-if="sonFactorList.length > 0"
                            v-for="(valueSwitch, indexSwitch) in sonFactorList"
                            :index="indexSwitch"
                        >
                            <van-col span="24" class="actionSheet-factor-item-col group-info">
                                <div class="actionSheet-group-info">
                                    <van-row>
                                        <draggable
                                            :list="valueSwitch"
                                            group="people"
                                            :options="{
                                                draggable: '.draggable-item',
                                                filter: '.no-drag, .actionSheet-factor-non, .actionSheet-factor-del',
                                                preventOnFilter: false
                                            }"
                                        >
                                            <!-- 有数据时 -->
                                            <template
                                                v-if="
                                                    valueSwitch.length > 0 &&
                                                    sonFactorList[indexSwitch] &&
                                                    sonFactorList[indexSwitch].length > 0
                                                "
                                            >
                                                <van-col
                                                    span="24"
                                                    class="actionSheet-group-item-col draggable-item"
                                                    v-for="(factorS, indexS) in valueSwitch"
                                                    :key="indexS"
                                                    v-if="sonFactorList[indexSwitch].length > 0"
                                                >
                                                    <!-- 常规因子 -->
                                                    <div class="actionSheet-group-item" v-if="factorS.yzType == 0" >
                                                        <div class="actionSheet-group-item-text">
                                                            <div
                                                                class="actionSheet-group-item-name"
                                                            >
                                                                {{ factorS.FactorName }}
                                                            </div>
                                                            <div
                                                                class="actionSheet-group-item-desc"
                                                            >
                                                                {{ factorS.SubClassName }}
                                                            </div>
                                                        </div>
                                                        <div class="actionSheet-group-item-num">
                                                            <div
                                                                class="actionSheet-group-item-zf"
                                                                :class="[
                                                                    judgeColor(factorS.RiZhangFu)
                                                                ]"
                                                            >
                                                                {{
                                                                    toFixedNum(
                                                                        factorS.RiZhangFu * 100,
                                                                        2,
                                                                        '%',
                                                                        true
                                                                    )
                                                                }}
                                                            </div>
                                                            <div class="actionSheet-group-item-zhi">
                                                                {{ factorS.XinHaoShuLiang }}只
                                                            </div>
                                                            <!-- 非按钮 -->
                                                            <div
                                                                class="actionSheet-factor-non"
                                                                @click.stop="
                                                                    sonToggleNon(
                                                                        factorS,
                                                                        indexSwitch,
                                                                        indexS
                                                                    )
                                                                "
                                                            >
                                                                <img
                                                                    src="@/assets/image/factor/non.png"
                                                                    alt=""
                                                                    srcset=""
                                                                    v-if="factorS.isNon"
                                                                />
                                                                <img
                                                                    src="@/assets/image/factor/non-n.png"
                                                                    alt=""
                                                                    srcset=""
                                                                    v-else
                                                                />
                                                            </div>
                                                            <!-- 删除按钮 -->
                                                            <div
                                                                class="actionSheet-factor-del"
                                                                @click.stop="
                                                                    delSonFactorGroupByIndex(
                                                                        factorS,
                                                                        indexSwitch
                                                                    )
                                                                "
                                                            >
                                                                <img
                                                                    src="@/assets/image/factor/del2.png"
                                                                    alt=""
                                                                    srcset=""
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- 非常规 -->
                                                     <div class="actionSheet-group-item" v-else >
                                                        <div class="actionSheet-group-item-text others-left">
                                                            <div
                                                                class="actionSheet-group-item-name"
                                                            >
                                                                {{ factorS.FactorName }}
                                                            </div>
                                                            <div
                                                                class="actionSheet-group-item-desc"
                                                            >
                                                                {{ factorS.SubClassName }}
                                                            </div>
                                                        </div>
                                                        <div class="actionSheet-group-item-num others-rigth">


                                                            <!-- 删除按钮 -->
                                                            <div
                                                                class="actionSheet-factor-del"
                                                                style="margin-left: auto;"
                                                                @click.stop="
                                                                    delSonFactorGroupByIndex(
                                                                        factorS,
                                                                        indexSwitch
                                                                    )
                                                                "
                                                            >
                                                                <img
                                                                    src="@/assets/image/factor/del2.png"
                                                                    alt=""
                                                                    srcset=""
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </van-col>
                                                <van-col span="24">
                                                    <div
                                                        class="actionSheet-factor-add-text no-drag"
                                                    >
                                                        拖拽因子至此
                                                    </div>
                                                </van-col>
                                            </template>
                                            <!-- 没数据时 -->
                                            <van-col
                                                v-else
                                                span="24"
                                                class="group-empty-col no-drag"
                                            >
                                                <div class="group-empty-col-text">拖拽因子至此</div>
                                                <div class="group-empty-col-box">
                                                    <div class="group-empty-col-box-left">
                                                        <div class="group-empty-col-box-item"></div>
                                                        <div class="group-empty-col-box-item"></div>
                                                        <div class="group-empty-col-box-item"></div>
                                                        <div class="group-empty-col-box-item"></div>
                                                    </div>
                                                    <div class="group-empty-col-box-right">
                                                        <div class="group-empty-col-box-item"></div>
                                                        <div class="group-empty-col-box-item"></div>
                                                    </div>
                                                </div>
                                                <div class="group-empty-col-box">
                                                    <div class="group-empty-col-box-left">
                                                        <div class="group-empty-col-box-item"></div>
                                                        <div class="group-empty-col-box-item"></div>
                                                        <div class="group-empty-col-box-item"></div>
                                                        <div class="group-empty-col-box-item"></div>
                                                    </div>
                                                    <div class="group-empty-col-box-right">
                                                        <div class="group-empty-col-box-item"></div>
                                                        <div class="group-empty-col-box-item"></div>
                                                    </div>
                                                </div>
                                            </van-col>
                                        </draggable>
                                    </van-row>
                                    <!-- 且&或文字的展示 -->
                                    <div class="actionSheet-group-qh-text">
                                        {{ checkedYzType === 'jj' ? '或' : '且' }}
                                    </div>
                                </div>
                                <!-- 删除按钮 -->
                                <div class="group-del" @click="delSonFactorGroup(indexSwitch)">
                                    <img src="@/assets/image/factor/del3.png" alt="" srcset="" />
                                </div>
                            </van-col>
                        </div>
                    </van-row>
                    <!-- 且&或文字的展示 -->
                    <div class="actionSheet-factor-qh-text">
                        {{ checkedYzType === 'jj' ? '且' : '或' }}
                    </div>
                </div>
                <!-- 添加按钮 -->
                <div class="group-add-btn" @click="addFactorGroup">{{ checkedYzType === 'jj' ? '添加并集组合' : '添加交集组合' }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import { removeValueFromArray, toFixedNum, judgeColor } from '@/utils/format';
export default {
    name: 'FactorSetOperatorModal',
    components: {
        draggable
    },
    data() {
        return {
            // 交并集
            // checkedYzType: 'jj' // jj 交集 bj 并集
            // 父因子数据
            // parentFactorList: [],
            // 子因子数据
            // sonFactorList: [],
        };
    },
    filters: {},
    // 侦听器
    watch: {},
    computed: {
        // 交并集类型
        checkedYzType() {
            // jj 交集 bj 并集
            return this.$store.state.checkedYzType;
        },
        parentFactorList() {
            return this.$store.state.checkedYzList;
        },
        // 关键：Vuex 双向绑定
        sonFactorList: {
            get() {
                return this.$store.state.groupYzList;
            },
            set(val) {
                this.$store.commit('setGroupYzList', val);
            }
        }
    },
    /**
     * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
     */
    created() {
        // 获取vuex 中的数据
        // console.log('this.$store.state.checkedYzList', this.$store.state.checkedYzList);
        // this.parentFactorList = this.$store.state.checkedYzList;
    },
    /**
     * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
     * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
     */
    mounted: function () {
        this.checkSonFactorList();
    },
    // 组件方法
    methods: {
        judgeColor,
        toFixedNum,
        // 点击清空组合池
        handleClear: function () {
            this.$store.commit('resetCheckedYzList');
            this.$store.commit('resetGroupYzList');
            this.handleBack();
        },
        // 点击添加子集组合
        addFactorGroup: function () {
            const list = [...this.sonFactorList];
            if (list.length > 4) {
                this.$toast('最多添加5个组合');
                return;
            }
            list.push([]);
            this.sonFactorList = list; // 触发 setter → mutation
        },
        //删除选中的因子 -
        delYz: function (item) {
            if (item.yzType == 0) {
                removeValueFromArray(this.parentFactorList, item.ID);
            } else {
                removeValueFromArray(this.parentFactorList, item.Info);
            }
            this.isEmptyInfo();
        },
        // 删除整个子组合
        delSonFactorGroup: function (index) {
            const list = [...this.sonFactorList];
            list.splice(index, 1);
            this.sonFactorList = list;

            this.isEmptyInfo();
        },
        // 删除子组合中的因子
        delSonFactorGroupByIndex: function (factor, index) {
            const list = this.sonFactorList.map((group) => [...group]);

            if (factor.yzType === 0) {
                removeValueFromArray(list[index], factor.ID);
            } else {
                removeValueFromArray(list[index], factor.Info);
            }

            // 组合空了就删
            if (list[index].length === 0) {
                list.splice(index, 1);
            }

            this.sonFactorList = list;
            this.isEmptyInfo();
        },
        // 判断是否都为空
        isEmptyInfo: function () {
            if (this.parentFactorList.length == 0 && this.sonFactorList.length == 0) {
                this.handleBack();
            }
        },
        // 返回上一级
        handleBack: function () {
            // this.checkSonFactorList();
            this.$emit('close');
        },
        /**
         * 子集 添加/取消 非的概念
         * @param factor 因子本身
         * @param index  组合的索引
         */
        sonToggleNon: function (factor, index, indexS) {
            console.log('factor==', factor);
            if (factor.yzType !== 0) {
                return;
            }
            const list = this.sonFactorList.map((group) => group.slice());
            list[index][indexS] = { ...list[index][indexS], isNon: !list[index][indexS].isNon };
            this.$store.commit('setGroupYzList', list);
        },
        /**
         * 父因子 添加/取消 非的概念
         * @param factor 因子本身
         * @param index  组合的索引
         */
        parentToggleNon: function (factor, index) {
            console.log('factor==', factor);
            if (factor.yzType !== 0) {
                return;
            }
            const list = this.parentFactorList.slice();
            list[index] = { ...list[index], isNon: !list[index].isNon };
            this.$store.commit('setCheckedYzList', list);
        },
        // 交并集类型切换
        toggleYzType: function (type) {
            this.$store.commit('setCheckedYzType', type);
        },
        //跳转选择参数页面
        goArguments: function () {
            // this.$store.commit('resetObj');
            // this.$store.commit('resetPublicHcID');

            if (
                this.$route.query.source === 'dyzcl' ||
                this.$route.query.source == 'appDyzHc' ||
                this.$route.query.source === 'appCl'
            ) {
                const query = {
                    token: this.$route.query.token || '',
                    mySource: this.$route.query.mySource,
                    source: this.$route.query.source,
                    themeStyleVs: this.$route.query.themeStyleVs || 0,
                    version: this.$route.query.version || '',
                    yzType:
                        this.$route.query.yzType == 'ETF' && this.defaultIndex == 1 ? 'ETF' : 'A',
                    createType: this.$route.query.createType || '',
                    dtzhHcCheckedYzList: this.$route.query.dtzhHcCheckedYzList || '',
                    dtzhCheckedYzList: this.$route.query.dtzhCheckedYzList || ''
                };

                this.$router.push({
                    path: '/dyzArguments',
                    name: 'DyzArguments',
                    query: query
                });
            } else if (
                this.$route.query.source === 'lhcl' ||
                this.$route.query.checkedYzList ||
                this.$route.query.source == 'appLhHc'
            ) {
                const query = {
                    token: this.$route.query.token || '',
                    type: this.getUrlQuery('type') ? this.getUrlQuery('type') : '',
                    mySource: this.$route.query.mySource,
                    source: this.$route.query.source || 'lhcl',
                    themeStyleVs: this.$route.query.themeStyleVs || 0,
                    version: this.$route.query.version || '',
                    yzType:
                        this.$route.query.yzType == 'ETF' && this.defaultIndex == 1 ? 'ETF' : 'A',
                    createType: this.$route.query.createType || '',
                    factorId: this.$route.query.factorId || '',
                    dtzhHcCheckedYzList: this.$route.query.dtzhHcCheckedYzList || '',
                    dtzhCheckedYzList: this.$route.query.dtzhCheckedYzList || '',
                    zxgHcCheckedYzList: this.$route.query.zxgHcCheckedYzList || '',
                    mark: this.$route.query.mark || ''
                };

                if (this.$route.query.checkedYzList) {
                    query.userid = this.$route.query.userid;
                    query.factorid = this.$route.query.factorid;
                    query.factornames = this.$route.query.userid;
                    query.checkedYzList = this.$route.query.checkedYzList;
                    query.zxgType = this.$route.query.zxgType || 0;
                } else if (this.$route.query.userid && !this.$route.query.checkedYzList) {
                    query.userid = this.$route.query.userid;
                    query.factorid = this.$route.query.factorid;
                    query.factornames = this.$route.query.userid;
                    query.zxgType = 0;
                }

                if (this.$route.query.zdyType == '1') {
                    query.zdyType = 1;
                    this.$router.push({
                        path: '/arguments',
                        name: 'arguments',
                        query: query
                    });
                } else {
                    this.$router.push({
                        path: '/lhArguments',
                        name: 'LhArguments',
                        query: query
                    });
                }
            }
        },
        // 校验一下 sonFactorList 是否有空数组, 如果有空数组就移除掉
        checkSonFactorList: function () {
            this.sonFactorList.forEach((item, index) => {
                if (item.length === 0) {
                    this.sonFactorList.splice(index, 1);
                }
            });
        }
    }
};
</script>

<style scoped lang="less">
.factorSetOperator {
    padding: 0 16px 35px 16px;
}
.actionSheet-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 9;
    .name {
        padding: 13px 0;
        font-size: 14px;
        color: #999;
    }
    .handle-clear {
        font-size: 14px;
        color: #286df7;
    }
}
// 交并集的tab
.actionSheet-tab {
    margin-bottom: 8px;
    text-align: center;
    .actionSheet-tab-bg {
        background-color: rgba(247, 247, 252, 1);
        border-radius: 6px;
        padding: 4px;
        display: inline-block;
        .actionSheet-tab-item {
            color: #4e5969;
            font-size: 13px;
            font-weight: 500;
            padding: 2px 8px;
            border-radius: 4px;
        }
        .active {
            background: #286df7;
            color: #e4e9fe;
        }
    }
}
// 交并集因子内容
.actionSheet-content-hidden {
    // max-height: 700px;
    // overflow: hidden;
    // overflow-y: auto;
}
.actionSheet-content {
    border-radius: 8px;
    padding: 10px;
    background: #f7f7fc;
    .actionSheet-factor-info {
        padding-left: 17px;
        border-left: 1px solid rgba(59, 133, 254, 1);
        border-radius: 10px;
        position: relative;
        .actionSheet-factor-item-col {
            position: relative;
        }
        .actionSheet-factor-item {
            background: #ffffff;
            border-radius: 6px;
            margin-bottom: 10px;
            padding: 6px 10px;
            display: flex;
            .others-left {
                width: 90% !important;
            }
            .others-rigth {
                width: 10% !important;
                background: rgba(0, 0, 0, 0) !important;
            }
            .actionSheet-factor-item-text {
                width: 30%;
                .actionSheet-factor-item-name {
                    color: #222222;
                    font-size: 14px;
                    font-weight: 500;
                    // 溢出隐藏显示...
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .actionSheet-factor-item-desc {
                    color: #999999;
                    font-size: 10px;
                    // 溢出隐藏显示...
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
            .actionSheet-factor-item-num {
                width: 70%;
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                align-content: center;
                justify-content: flex-start;
                align-items: center;
                background: rgba(0, 0, 0, 0.02);
                border-radius: 4px;
                .actionSheet-factor-item-zf {
                    font-size: 12px;
                    font-weight: 600;
                    margin-left: 12px;
                    margin-right: 8px;
                }
                .actionSheet-factor-item-zhi {
                    color: #555555;
                    font-size: 12px;
                }
                // 非按钮
                .actionSheet-factor-non {
                    margin-left: auto;
                    width: 16px;
                    height: 16px;
                    img {
                        width: 100%;
                        height: 100%;
                        display: block;
                    }
                }
                // 删除按钮
                .actionSheet-factor-del {
                    margin-left: 18px;
                    width: 16px;
                    height: 16px;
                    img {
                        width: 100%;
                        height: 100%;
                        display: block;
                    }
                }
            }
        }

        /* 让最后一条因子没有 margin-bottom */
        .actionSheet-factor-item-col:last-child .actionSheet-factor-item {
            margin-bottom: 0;
        }

        // 且跟或的文字按钮 靠左居中
        .actionSheet-factor-qh-text {
            position: absolute;
            left: -9px;
            top: 50%;
            transform: translateY(-50%);
            background: #e5ecfa;
            border-radius: 4px;
            padding: 4px 2px;
            color: #286df7;
            font-size: 14px;
        }

        // 分组中的样式
        .group-info {
            border: 1px solid #e7e9f0;
            padding: 8px 10px;
            padding-right: 3px;
            border-radius: 8px;
            margin-top: 10px;
            position: relative;
        }
        .group-del {
            position: absolute;
            top: -8px;
            right: -8px;
            width: 16px;
            height: 16px;
            img {
                width: 100%;
                height: 100%;
                display: block;
            }
        }
        .actionSheet-group-info {
            position: relative;
            padding-left: 15px;
            border-left: 1px solid #3b85fe;
            border-radius: 10px;
            // 空数据
            .group-empty-col {
                .group-empty-col-text {
                    text-align: center;
                    color: #949da8;
                    font-size: 12px;
                    margin-bottom: 5px;
                }
                .group-empty-col-box {
                    height: 28px;
                    border: 1px dashed #D9D9D9;
                    border-radius: 4px;
                    // padding: 4px 6px;
                    display: flex;
                    margin-bottom: 8px;
                    .group-empty-col-box-left {
                        width: 50%;
                        border-right: 1px dashed #e7e9f0;
                        display: flex;
                        flex-direction: row;
                        flex-wrap: nowrap;
                        align-content: center;
                        justify-content: space-around;
                        align-items: center;
                        padding: 6px;
                        .group-empty-col-box-item {
                            background: #ECECF0;
                            border-radius: 2px;
                            height: 20px;
                            display: inline-block;
                            width: 24%;
                        }
                    }
                    .group-empty-col-box-right {
                        width: 50%;

                        display: flex;
                        flex-direction: row;
                        flex-wrap: nowrap;
                        align-content: center;
                        justify-content: space-around;
                        align-items: center;
                        padding: 6px;
                        .group-empty-col-box-item {
                            background: #ECECF0;
                            border-radius: 2px;
                            height: 20px;
                            display: inline-block;
                            width: 49%;
                        }
                    }
                }
            }
        }
        .actionSheet-factor-add-text {
            border: 1px dashed #d9d9d9;
            height: 36px;
            line-height: 36px;
            border-radius: 4px;
            text-align: center;
            color: #949da8;
            font-size: 12px;
        }
        .actionSheet-group-item-col {
            position: relative;
            .actionSheet-group-item {
                background: #ffffff;
                border-radius: 6px;
                margin-bottom: 10px;
                padding: 6px 10px;
                display: flex;
                padding-right: 6px;
                .others-left {
                    width: 90% !important;
                }
                .others-rigth {
                    width: 10% !important;
                    background: rgba(0, 0, 0, 0) !important;
                }
                .actionSheet-group-item-text {
                    width: 30%;
                    .actionSheet-group-item-name {
                        color: #222222;
                        font-size: 14px;
                        font-weight: 500;
                        // 溢出隐藏显示...
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    .actionSheet-group-item-desc {
                        color: #999999;
                        font-size: 10px;
                        // 溢出隐藏显示...
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }
                .actionSheet-group-item-num {
                    width: 70%;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: nowrap;
                    align-content: center;
                    justify-content: flex-start;
                    align-items: center;
                    background: rgba(0, 0, 0, 0.02);
                    border-radius: 4px;
                    .actionSheet-group-item-zf {
                        font-size: 12px;
                        font-weight: 600;
                        margin-left: 12px;
                        margin-right: 8px;
                    }
                    .actionSheet-group-item-zhi {
                        color: #555555;
                        font-size: 12px;
                    }
                    // 非按钮
                    .actionSheet-factor-non {
                        margin-left: auto;
                        width: 16px;
                        height: 16px;
                        img {
                            width: 100%;
                            height: 100%;
                            display: block;
                        }
                    }
                    // 删除按钮
                    .actionSheet-factor-del {
                        margin-left: 18px;
                        width: 16px;
                        height: 16px;
                        img {
                            width: 100%;
                            height: 100%;
                            display: block;
                        }
                    }
                }
            }
        }
        /* 让最后一条因子没有 margin-bottom */
        .actionSheet-group-info .actionSheet-group-item-col:last-child .actionSheet-group-item {
            margin-bottom: 0;
        }
        // 且跟或的文字按钮 靠左居中
        .actionSheet-group-qh-text {
            position: absolute;
            left: -9px;
            top: 50%;
            transform: translateY(-50%);
            background: #e5ecfa;
            border-radius: 4px;
            padding: 4px 2px;
            color: #286df7;
            font-size: 14px;
        }
    }
    // 添加组合按钮
    .group-add-btn {
        background: rgba(40, 109, 247, 0.07);
        border-radius: 4px;
        color: #286df7;
        font-size: 14px;
        width: 80%;
        height: 36px;
        margin: 10px auto;
        text-align: center;
        line-height: 36px;
    }
}

.group-submit-btn-box {
    margin-top: 16px;
    .group-submit-btn {
        background-color: rgba(40, 109, 247, 1);
        width: 100%;
        font-weight: 600;
        color: #ffffff;
        font-size: 16px;
    }
}

// 黑版样式
.black_theme {
    // 交并集的tab
    .actionSheet-tab {
        .actionSheet-tab-bg {
            background-color: #20232e;
            .actionSheet-tab-item {
                color: #aab9d1;
            }
            .active {
                background: #3b85fe;
                color: #e4e9fe;
            }
        }
    }
    // 交并集内容
    .actionSheet-content {
        background: #1f222e;
        .actionSheet-factor-info {
            border-left: 1px solid rgba(59, 133, 254, 1);

            .actionSheet-factor-item {
                background: #272935;
                .actionSheet-factor-item-text {
                    .actionSheet-factor-item-name {
                        color: #e4e9fe;
                    }
                    .actionSheet-factor-item-desc {
                        color: #999999;
                    }
                }
                .actionSheet-factor-item-num {
                    background: rgba(255, 255, 255, 0.02);
                    .actionSheet-factor-item-zhi {
                        color: #aab9d1;
                    }
                }
            }

            // 且跟或的文字按钮 靠左居中
            .actionSheet-factor-qh-text {
                background: #314770;
                color: #3b85fe;
            }

            // 分组中的样式
            .group-info {
                border: 1px solid #353843;
            }
            .actionSheet-group-info {
                border-left: 1px solid #3b85fe;
                // 空数据
                .group-empty-col {
                    .group-empty-col-text {
                        color: #697689;
                    }
                    .group-empty-col-box {
                        border: 1px dashed rgba(255, 255, 255, 0.1);
                        .group-empty-col-box-left {
                            border-right: 1px dashed #3c404c;
                            .group-empty-col-box-item {
                                background: rgba(255, 255, 255, 0.03);
                            }
                        }
                        .group-empty-col-box-right {
                            .group-empty-col-box-item {
                                background: rgba(255, 255, 255, 0.03);
                            }
                        }
                    }
                }
            }
            .actionSheet-factor-add-text {
                border: 1px dashed #353843;
                color: #697689;
            }
            .actionSheet-group-item-col {
                .actionSheet-group-item {
                    background: #272935;
                    .actionSheet-group-item-text {
                        .actionSheet-group-item-name {
                            color: #e4e9fe;
                        }
                        .actionSheet-group-item-desc {
                            color: #999999;
                        }
                    }
                    .actionSheet-group-item-num {
                        background: rgba(255, 255, 255, 0.02);

                        .actionSheet-group-item-zhi {
                            color: #aab9d1;
                        }
                    }
                }
            }

            // 且跟或的文字按钮 靠左居中
            .actionSheet-group-qh-text {
                background: #314770;
                color: #3b85fe;
            }
        }
        // 添加组合按钮
        .group-add-btn {
            background: rgba(59, 133, 254, 0.1);;
            color: #5495ff;
        }
    }
}
</style>
